export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_q02_a.75afb540.png";